import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about">
      {/* Eyebrow */}
      <div className="about-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Our Story</span>
        <div className="eyebrow-line"></div>
      </div>

      {/* Main Heading */}
      <h1 className="about-title">
        Swayam Homes: Built on <em>Trust & Resilience</em>
      </h1>

      {/* Intro Section */}
      <div className="about-intro">
        <p className="about-intro-text">
          From humble roots in farming to becoming one of Hyderabad's most trusted real estate developers, 
          Swayam Homes is a testament to vision, determination, and an unwavering commitment to customer satisfaction.
        </p>
      </div>

      {/* Founder Section */}
      <div className="about-founder-section">
        <div className="founder-header">
          <h2>The Founder's Journey</h2>
          <div className="accent-line"></div>
        </div>

        <div className="founder-content">
          <div className="founder-story">
            <h3>Vantala Jangaiah Yadav</h3>
            <p className="founder-subtitle">Founder & Managing Director</p>

            <div className="journey-timeline">
              <div className="journey-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p className="timeline-year">2003</p>
                  <p className="timeline-description">
                    Starting with no real estate background, Vantala Jangaiah Yadav joined Siri Nidhi Homes 
                    as an Admin Peon, determined to learn the industry from the ground up.
                  </p>
                </div>
              </div>

              <div className="journey-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p className="timeline-year">Parallel Journey</p>
                  <p className="timeline-description">
                    While building real estate expertise, he also established and ran Raising Motor Driving School, 
                    demonstrating entrepreneurial spirit and business acumen beyond a single domain.
                  </p>
                </div>
              </div>

              <div className="journey-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p className="timeline-year">2015</p>
                  <p className="timeline-description">
                    Armed with over a decade of industry knowledge, resilience, and an unshakeable belief in customer-centric development, 
                    Vantala Jangaiah Yadav established Swayam Homes Pvt Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Company Achievements */}
      <div className="about-achievements">
        <h2>Our Impact</h2>
        <div className="achievements-grid">
          <div className="achievement-card">
            <div className="achievement-number">800+</div>
            <div className="achievement-label">Acres Developed</div>
            <p className="achievement-description">
              Transforming vast landscapes into thriving, sustainable communities across Hyderabad's premium locations.
            </p>
          </div>

          <div className="achievement-card">
            <div className="achievement-number">Thousands</div>
            <div className="achievement-label">Plots Sold</div>
            <p className="achievement-description">
              Creating dreams and building futures for countless families who trust us with their most important investment.
            </p>
          </div>

          <div className="achievement-card">
            <div className="achievement-number">2020-21</div>
            <div className="achievement-label">Pandemic Resilience</div>
            <p className="achievement-description">
              Maintained exceptional sales performance during challenging times, a testament to the unwavering trust our customers place in us.
            </p>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="about-values">
        <h2>Our Values</h2>
        <div className="values-container">
          <div className="value-item">
            <div className="value-icon">🤝</div>
            <h3>Customer-Centric</h3>
            <p>
              Every decision we make is rooted in understanding and serving our customers' needs. 
              Your satisfaction is our greatest achievement.
            </p>
          </div>

          <div className="value-item">
            <div className="value-icon">💪</div>
            <h3>Resilience</h3>
            <p>
              From farming backgrounds to real estate leadership, we believe in turning challenges into opportunities 
              and adversity into growth.
            </p>
          </div>

          <div className="value-item">
            <div className="value-icon">🔒</div>
            <h3>Trust</h3>
            <p>
              Built through consistent delivery, transparent practices, and genuine relationships. 
              Trust is the foundation of everything we do.
            </p>
          </div>

          <div className="value-item">
            <div className="value-icon">🌟</div>
            <h3>Excellence</h3>
            <p>
              We don't just develop plots; we create lifestyles. Excellence in design, execution, 
              and service is non-negotiable.
            </p>
          </div>
        </div>
      </div>

      {/* Closing CTA */}
      <div className="about-closing">
        <p>
          At Swayam Homes, we're not just building communities—we're building legacies. 
          Join thousands of satisfied customers who have made Swayam their home.
        </p>
        <button className="cta-button">Connect With Us</button>
      </div>
    </section>
  );
};

export default About;
